import * as React from "react";
const SvgGateways = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Gateways">
    <rect x={165.08} y={193.33} fill="currentColor" rx={7.5} ry={7.5} />
    <circle cx={74.06} cy={200.83} r={11.41} fill="currentColor" />
    <circle cx={44.21} cy={200.83} r={11.41} fill="currentColor" />
    <path
      fill="currentColor"
      d="M240.13 243.28H15.87c-4.14 0-7.5-3.36-7.5-7.5v-83.75c0-4.14 3.36-7.5 7.5-7.5h67.28c3.56 0 6.63 2.51 7.35 6 3.62 17.71 19.39 30.56 37.5 30.56s33.88-12.85 37.5-30.56c.71-3.49 3.78-6 7.35-6h67.28c4.14 0 7.5 3.36 7.5 7.5v83.75c0 4.14-3.36 7.5-7.5 7.5m-216.76-15h209.26v-68.75H178.6c-7.12 21.51-27.49 36.55-50.6 36.55s-43.48-15.05-50.6-36.55H23.37z"
    />
    <circle cx={128} cy={142.43} r={11.41} fill="currentColor" />
    <path
      fill="currentColor"
      d="M162.47 112.72c-2.81 2.42-6.92 2.39-9.77.02a38.62 38.62 0 0 0-49.4 0c-2.85 2.37-6.97 2.41-9.77-.02-3.5-3.02-3.47-8.47.08-11.43 9.58-8.01 21.72-12.48 34.39-12.48s24.81 4.47 34.39 12.48c3.55 2.97 3.58 8.41.08 11.43M197.13 82.85c-2.93 2.53-7.28 2.32-10.04-.4-15.7-15.47-36.88-24.22-59.09-24.22s-43.39 8.75-59.09 24.21c-2.76 2.72-7.11 2.93-10.04.4l-.15-.13c-3.26-2.81-3.49-7.83-.43-10.86C76.8 53.57 101.79 43.22 128 43.22s51.21 10.34 69.71 28.63c3.06 3.02 2.83 8.04-.43 10.86l-.15.13Z"
    />
  </svg>
);
export default SvgGateways;
